import { render, staticRenderFns } from "./ExampleMpsDataTable.vue?vue&type=template&id=5c2ba2b3"
import script from "./ExampleMpsDataTable.vue?vue&type=script&lang=js"
export * from "./ExampleMpsDataTable.vue?vue&type=script&lang=js"
import style0 from "./ExampleMpsDataTable.vue?vue&type=style&index=0&id=5c2ba2b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports